import { RootState } from 'rootReducer';

export const logoutSelector = (state: RootState) => state.commonReducer.logoutReducer;
export const branchTitleSelector = (state: RootState) => state.commonReducer.logoutReducer.branchTitle;
